import styled from "styled-components";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  UncontrolledAccordion,
} from "reactstrap";

import PrimaryThemeForm from "../../forms/app/PrimaryThemeForm";
import SecondaryThemeForm from "../../forms/app/SecondaryThemeForm";
import TertiaryThemeForm from "../../forms/app/TertiaryThemeForm";
import FontConfiguration from "./FontConfiguration";

const Container = styled.div`
  height: calc(100vh - 74px);
  padding: 10px;
  overflow: scroll;
`;

const WLThemeSection = {
  Colors: "colors",
  Fonts: "fonts",
};

export default function SideBar() {
  return (
    <Container className="SideBar">
      <UncontrolledAccordion defaultOpen={WLThemeSection.Colors}>
        <AccordionItem>
          <AccordionHeader targetId={WLThemeSection.Colors}>
            <span>Colors</span>
          </AccordionHeader>
          <AccordionBody accordionId={WLThemeSection.Colors}>
            <PrimaryThemeForm />
            <SecondaryThemeForm />
            <TertiaryThemeForm />
          </AccordionBody>
        </AccordionItem>
        <AccordionItem>
          <AccordionHeader targetId={WLThemeSection.Fonts}>
            <span>Fonts</span>
          </AccordionHeader>
          <AccordionBody accordionId={WLThemeSection.Fonts}>
            <FontConfiguration />
          </AccordionBody>
        </AccordionItem>
      </UncontrolledAccordion>
    </Container>
  );
}
